import { Loader2 } from "lucide-react";
import { useParams } from "react-router";
import { useDeepResearchReport } from "@/hooks/api/use-deep-research";
import { DatasetReport } from "./dataset-report";

/**
 * Wrapper component that provides routing to the unified DatasetReport component.
 * Uses store hydration via React Query onSuccess.
 */
export function DatasetWrapper() {
  const { datasetId } = useParams();
  const { data: report, isLoading, error } = useDeepResearchReport(datasetId);

  if (isLoading) {
    return (
      <div className="flex h-[50vh] items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (error || !report) {
    return (
      <div className="flex h-[50vh] items-center justify-center">
        <div className="text-center">
          <h2 className="text-lg font-semibold">Dataset not found</h2>
          <p className="text-sm text-muted-foreground">
            The dataset you're looking for doesn't exist or you don't have
            access to it.
          </p>
        </div>
      </div>
    );
  }

  return <DatasetReport reportId={report.id} />;
}
